import { z } from "zod";

export const UpdateExpertProfileRequestSchema = z.object({
    expert: z
        .object({
            bio: z.string().max(5000).optional(),
            country: z.string().max(10).optional(),
            city_id: z.number().int().nullable().optional(),
            starting_price: z.number().optional(),
            timezone: z.string().max(255).optional(),
            phone_no: z.string().max(255).optional(),
            regions_served: z.array(z.string()).optional(),
            geo_regions: z.array(z.string()).optional(),
            languages: z.array(z.string()).optional(),
            profile_picture_id: z.string().optional().nullable(),
        })
        .optional(),
    freelancer: z
        .object({
            first_name: z.string().max(255).optional(),
            last_name: z.string().max(255).optional(),
            role: z.string().max(255).optional(),
        })
        .optional(),
    agency: z
        .object({
            agency_name: z.string().max(255).optional(),
            agency_type: z.string().max(255).optional(),
            agency_type_fields: z
                .object({
                    app_tier: z.string().max(255).optional(),
                })
                .optional(),
            representative_name: z.string().max(255).optional(),
            representative_role: z.string().max(255).optional(),
            representative_picture_id: z.string().optional().nullable(),
        })
        .optional(),
    social_links: z
        .object({
            linkedin_url: z.string().max(500).optional().nullable(),
            github_url: z.string().max(500).optional().nullable(),
            x_url: z.string().max(500).optional().nullable(),
            fiverr_url: z.string().max(500).optional().nullable(),
            upwork_url: z.string().max(500).optional().nullable(),
            toptal_url: z.string().max(500).optional().nullable(),
            storetasker_url: z.string().max(500).optional().nullable(),
            other_listing_url: z.string().max(500).optional().nullable(),
            website: z.string().max(500).optional().nullable(),
            shopify_directory_link: z.string().max(500).optional().nullable(),
            booking_call_url: z.string().max(2048).optional().nullable(),
            google_merchant: z.string().max(2048).optional().nullable(),
        })
        .optional(),
    address: z
        .object({
            address: z.string().max(1000).optional(),
            longitude: z.number().optional(),
            latitude: z.number().optional(),
        })
        .optional(),
});

export type UpdateExpertProfileRequest = z.infer<typeof UpdateExpertProfileRequestSchema>;

export const ChangeExpertPasswordRequestSchema = z.object({
    current_password: z.string().min(1),
    new_password: z.string().min(8),
});

export type ChangeExpertPasswordRequest = z.infer<typeof ChangeExpertPasswordRequestSchema>;

export const RequestExpertEmailChangeRequestSchema = z.object({
    new_email: z.email(),
    password: z.string().min(1),
});

export type RequestExpertEmailChangeRequest = z.infer<typeof RequestExpertEmailChangeRequestSchema>;

export const VerifyExpertEmailChangeRequestSchema = z.object({
    token: z.string(),
    email: z.email(),
});

export type VerifyExpertEmailChangeRequest = z.infer<typeof VerifyExpertEmailChangeRequestSchema>;
